<app-app-loader *ngIf="isloading"></app-app-loader>

<app-app-banner></app-app-banner>

<app-app-why-choose></app-app-why-choose>

<app-app-features></app-app-features>

<app-app-screenshots></app-app-screenshots>

<app-app-how-to-use></app-app-how-to-use>

<app-app-faq></app-app-faq>

<app-app-testimonials></app-app-testimonials>
